import { useCallback } from "react";

import { GenerationMode } from "shared/types";
import classNames from "shared/utils/classNames";
import { ReactComponent as IconSend } from "assets/images/icons/send.svg";

type Props = {
  generationMode: GenerationMode;
  setGenerationMode: React.Dispatch<React.SetStateAction<GenerationMode>>;
  eventSource: EventSource | null;
  disabled: boolean;
};

const SendButton = (props: Props) => {
  const { generationMode, eventSource, setGenerationMode, disabled } = props;

  const stopGeneration = useCallback(() => {
    eventSource?.close();
    setGenerationMode(null);
  }, [eventSource, setGenerationMode]);

  const generatingClassName = classNames(
    "absolute border-2 border-solid border-[var(--chatBotOrDarkColor)]",
  );

  return (
    <div className="button-container">
      {!generationMode && (
        <button
          type="submit"
          className={classNames(
            "submit-button border-solid border-[var(--chatBotOrDarkColor)] bg-[var(--chatBotOrDarkColor)] p-0 text-white",
            disabled
              ? "cursor-default opacity-50"
              : "hover:border-solid hover:bg-white hover:text-[--chatBotOrDarkColor]",
          )}
        >
          <IconSend />
        </button>
      )}
      {generationMode && (
        <button
          type="submit"
          className="relative flex h-[24px] w-[24px] items-center justify-center border-0 bg-transparent"
          onClick={() => stopGeneration()}
        >
          <div
            className={classNames(
              generatingClassName,
              "m-[9px] h-3 w-3 rounded-sm",
            )}
          />
          <div
            className={classNames(
              generatingClassName,
              "h-full w-full rounded-2xl opacity-25",
            )}
          />
          <div
            className={classNames(
              generatingClassName,
              "h-full w-full rounded-2xl",
            )}
          />
        </button>
      )}
    </div>
  );
};

export default SendButton;
